import { render, staticRenderFns } from "./AssemblyArticleDialog.vue?vue&type=template&id=112496fe&"
import script from "./AssemblyArticleDialog.vue?vue&type=script&lang=js&"
export * from "./AssemblyArticleDialog.vue?vue&type=script&lang=js&"
import style0 from "./AssemblyArticleDialog.vue?vue&type=style&index=0&id=112496fe&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports